import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { agreementStatusOptions } from 'AgreementListPackage/AgreementListFiltersModule/constants/agreementStatusOptions';

interface IAgreementStatusCell {
  statusCodeList: string[];
}

export function AgreementStatusCell<T extends IAgreementStatusCell>({ row }: Readonly<ITableRenderCell<T>>) {
  return <div>{row.statusCodeList.map(i => agreementStatusOptions.find(j => j.id === i)?.label || i).join(', ')}</div>;
}
